import * as React from "react";
const SvgFiRrSolarSystem = (props) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <g clipPath="url(#fi-rr-solar-system_svg__a)">
      <path
        fill="#062147"
        d="M8 10a2 2 0 1 1-.001-3.999A2 2 0 0 1 8 10m11.5-3a2.5 2.5 0 1 0 0-5 2.5 2.5 0 0 0 0 5m-6 5a1.5 1.5 0 1 0-3.001.001A1.5 1.5 0 0 0 13.5 12m10.048-3.272a.998.998 0 1 0-1.923.545c.249.883.376 1.801.376 2.728 0 5.514-4.486 10-10 10S2 17.514 2 12 6.486 2 12 2c.927 0 1.845.127 2.728.376a.998.998 0 1 0 .545-1.923 12 12 0 0 0-3.272-.452C5.383 0 0 5.383 0 12s5.383 12 12 12 12-5.383 12-12c0-1.111-.152-2.212-.452-3.272M11 6a1 1 0 0 0 1 1c2.757 0 5 2.243 5 5s-2.243 5-5 5-5-2.243-5-5a1 1 0 1 0-2 0c0 3.859 3.141 7 7 7s7-3.141 7-7-3.141-7-7-7a1 1 0 0 0-1 1"
      />
    </g>
    <defs>
      <clipPath id="fi-rr-solar-system_svg__a">
        <path fill="#fff" d="M0 0h24v24H0z" />
      </clipPath>
    </defs>
  </svg>
);
export default SvgFiRrSolarSystem;
